module.exports = __webpack_public_path__ + "static/media/exterior_back.ffb4da23.png";